import { v4 } from "uuid";

export const cleanFile = (originalFile) => {
  if (!originalFile) {
    return null;
  }
  return new File([originalFile], v4(), {
    type: originalFile.type,
    lastModified: originalFile.lastModified,
  });
};
